import React from 'react';
import PromotionsPage from '../../components/Sales/PromotionsPage/PromotionsPage';

const PromotionsPageContainer = () => (
  <PromotionsPage />
);

export default PromotionsPageContainer;



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/PromotionsPage.jsx